import { render, staticRenderFns } from "./CreateSkuRateHistoryDialog.vue?vue&type=template&id=68abdcb8"
import script from "./CreateSkuRateHistoryDialog.vue?vue&type=script&lang=js"
export * from "./CreateSkuRateHistoryDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports